import ApiService from './ApiService'
export const AccountService = {

  get (serviceUrl, slug, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${serviceUrl}/admin/users`, slug, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (serviceUrl, params) {
    return ApiService.post(`${serviceUrl}/admin/users`, params)
  },

  update (serviceUrl, resource, params) {
    return ApiService.put(`${serviceUrl}/admin/users/${resource}`, params)
  },

  destroy (serviceUrl, resource) {
    return ApiService.delete(`${serviceUrl}/admin/users/${resource}`)
  },

  getHearingTrainingLevels (serviceUrl, resource) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${serviceUrl}/admin/users/${resource}/hearing-training`)
        .then(response => {
          resolve(response.data.data)
        })
        .catch(errors => {
          console.log(errors)
          resolve([])
        })
    })
  },

  downloadPDF (serviceUrl, userId, resource, params = {}) {
    return ApiService.blob(`${serviceUrl}/admin/users/${userId}/hearing-tests/${resource}/pdf`, params)
  }
}

export const AccountPermissionsService = {

  get (serviceUrl) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${serviceUrl}/admin/accounts-permissions`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },
  store (serviceUrl, entityId, data) {
    return ApiService.post(`${serviceUrl}/admin/entities/${entityId}/account-permissions`, data)
  }
}

export const InvitationService = {

  store (serviceUrl, params) {
    return ApiService.post(`${serviceUrl}/admin/invitations`, params)
  }
}

export const AppointmentService = {

  query (serviceUrl, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${serviceUrl}/admin/appointments`, params)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },

  get (serviceUrl, slug, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${serviceUrl}/admin/appointments`, slug, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (serviceUrl, params) {
    return ApiService.post(`${serviceUrl}/admin/appointments`, params)
  },

  update (serviceUrl, slug, params) {
    return ApiService.patch(`${serviceUrl}/admin/appointments/${slug}`, params)
  },

  destroy (serviceUrl, slug) {
    return ApiService.delete(`${serviceUrl}/admin/appointments/${slug}`)
  },

  start (serviceUrl, resource) {
    return new Promise((resolve, reject) => {
      return ApiService.post(`${serviceUrl}/admin/appointments/${resource}/start`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  reopen (serviceUrl, resource) {
    return new Promise((resolve, reject) => {
      return ApiService.post(`${serviceUrl}/admin/appointments/${resource}/reopen`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  end (serviceUrl, resource, params) {
    return ApiService.post(`${serviceUrl}/admin/appointments/${resource}/end`, params)
  },

  nextStartedAppointment (serviceUrl, resource) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${serviceUrl}/admin/appointments/${resource}/next-started-appointment`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  requestCall (serviceUrl, resource, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${serviceUrl}/admin/appointments/${resource}/request-call`, data)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  cancelCallRequest (serviceUrl, resource) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${serviceUrl}/admin/appointments/${resource}/cancel-call`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  rateCallRequest (serviceUrl, resource, data) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${serviceUrl}/admin/appointments/${resource}/rate-call`, data)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getUserActiveAppointment (serviceUrl) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${serviceUrl}/admin/appointments/active-appointments`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getTypes (serviceUrl) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${serviceUrl}/admin/appointment-types`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  getStatuses (serviceUrl) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${serviceUrl}/admin/appointment-statuses`)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  spice (serviceUrl, data) {
    return ApiService.post(`${serviceUrl}/admin/appointments/spice-import`, data)
  },

  getByEntityActivityUser (serviceUrl, entityActivityUserId, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${serviceUrl}/admin/entities-activities-users/${entityActivityUserId}/appointments`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  /**
   * Update appointment entityActivityUser
   * @param {*} appointmentId
   * @param {*} params
   */
  updateEntityActivityUser (serviceUrl, appointmentId, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${serviceUrl}/admin/appointments/${appointmentId}/entity-activity-user`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  bulkUpdateEntitiesActivitiesUsers (serviceUrl, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${serviceUrl}/admin/entities-activities-users/update-appointments`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  appointmentsBulkUpdateActivity (serviceUrl, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.patch(`${serviceUrl}/admin/appointments/bulk-update-activities`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  updateAppointmentPerson (serviceUrl, slug, params = {}) {
    return ApiService.patch(`${serviceUrl}/admin/appointments/${slug}/person`, params)
  },

  transferAppointments (serviceUrl, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${serviceUrl}/admin/appointments/transfer-appointments`, params)
        .then(response => resolve(response.data.data))
        .catch(err => reject(err))
    })
  }
}

export const PersonService = {

  query (serviceUrl, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${serviceUrl}/admin/people`, params)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },

  get (serviceUrl, slug, params = {}) {
    return new Promise((resolve, reject) => {
      ApiService.get(`${serviceUrl}/admin/people`, slug, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  store (serviceUrl, params) {
    return ApiService.post(`${serviceUrl}/admin/people`, params)
  },

  update (serviceUrl, resource, params) {
    return ApiService.patch(`${serviceUrl}/admin/people/${resource}`, params)
  },

  mergePersonData (serviceUrl, params) {
    return ApiService.post(`${serviceUrl}/admin/people/merge`, params)
  },

  getMergePersonResult (serviceUrl, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${serviceUrl}/admin/people/merge-result`, params)
        .then(response => resolve(response.data.data))
        .catch(errors => reject(errors))
    })
  },

  destroy (serviceUrl, resource) {
    return ApiService.delete(`${serviceUrl}/admin/people/${resource}`)
  }
}

export const StatisticsService = {
  getDispenserStatistics (serviceUrl, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${serviceUrl}/admin/statistics/dispenser-statistics`, params)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  },

  getAudiologistStatistics (serviceUrl, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(`${serviceUrl}/admin/statistics/audiologist-statistics`, params)
        .then(response => resolve(response.data.data))
        .catch(error => reject(error))
    })
  }
}
